import React, { useState } from "react";
import "../style/Contact.css";
import contactBg from "../../assets/herosection-for-service.png";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaWhatsapp,
} from "react-icons/fa";

const Contact = () => {
  const [openMap, setOpenMap] = useState(false);

  return (
    <div className="contact-page">
      
      {/* ================= HERO SECTION ================= */}
      <div
        className="contact-hero"
        style={{ backgroundImage: `url(${contactBg})` }}
      >
        <div className="contact-overlay">
          <h1>Contact Us</h1>
          <p>We are ready to move your cargo anywhere in the world</p>
        </div>
      </div>

      {/* ================= CONTACT SECTION ================= */}
      <div className="contact-container">
        <div className="contact-info">
          <h2>Get In Touch</h2>
          <p>
            Our logistics experts are always available to help you with shipping,
            freight, warehousing, and custom logistics solutions.
          </p>

          {/* Address (OPEN MODAL) */}
          <div
            className="info-box clickable"
            onClick={() => setOpenMap(true)}
          >
            <FaMapMarkerAlt className="info-icon" />
            <div>
              <h4>Office Address</h4>
              <p>
                333/1 DAYA COMPLEX RANGPURI NEAR TATA TELCO  
                NEW DELHI 110037
              </p>
            </div>
          </div>

          {/* Phone */}
          <a href="tel:+919616650556" className="info-box clickable">
            <FaPhoneAlt className="info-icon" />
            <div>
              <h4>Phone</h4>
              <p>+91 96166 50556</p>
            </div>
          </a>

          {/* Email */}
          <a
            href="mailto:vijay.sehrawat@pfalogistics.com"
            className="info-box clickable"
          >
            <FaEnvelope className="info-icon" />
            <div>
              <h4>Email</h4>
              <p>vijay.sehrawat@pfalogistics.com</p>
            </div>
          </a>

          {/* WhatsApp */}
          <a
            href="https://wa.me/919616650556?text=Hello%20I%20am%20interested%20in%20your%20logistics%20services"
            target="_blank"
            rel="noopener noreferrer"
            className="info-box clickable"
          >
            <FaWhatsapp className="info-icon whatsapp" />
            <div>
              <h4>WhatsApp</h4>
              <p>Chat with us instantly</p>
            </div>
          </a>
        </div>
      </div>

      {/* ================= MAP MODAL ================= */}
      {openMap && (
        <div className="map-modal">
          <div className="map-content">
            <span
              className="map-close"
              onClick={() => setOpenMap(false)}
            >
              ✕
            </span>

           <iframe title="Office Location"src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56058.665203537144!2d77.00815200805664!3d28.579773366439284!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1b90f62041a3%3A0xed6c70d5f0dd96b6!2sDaya%20complex!5e0!3m2!1sen!2sin!4v1770840854634!5m2!1sen!2sin"width="100%"height="100%"style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"/>

          </div>
        </div>
      )}
    </div>
  );
};

export default Contact;
